import { render, staticRenderFns } from "./IconDash.vue?vue&type=template&id=b81d64f4"
import script from "./IconDash.vue?vue&type=script&lang=js"
export * from "./IconDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports